// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2L5yh","white":"style_white__3sO1E","gray":"style_gray__1gtFF","containerInner":"style_containerInner__DBmll","logo":"style_logo__2CVHT"};